const defaultPrice = 14.95


export default {
  defaultPrice,
}
